module.exports = __webpack_public_path__ + "img/helal-ahmar.74ae530.webp";